<template>
  <b-row class="px-sm-5 px-md-5 px-lg-0 pt-sm-3 ">
    <b-col cols="12" class="mb-3">
      <PageTitle title="Solicitações de profissionais" />
    </b-col>
    <b-col cols="12" class="mb-5">
      <div>
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=_BC0cDGOjYM&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=33', 
            title: 'Solicitações de profissionais' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a class="btn btn-success" href="https://api.construp.com.br/assets/Solicitações de profissionais.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
      </div>
    </b-col>
    
    <b-col cols="12" sm="12" md="12" lg="6" xl="6">
      <label class="font-weight-bold">Status da solicitação</label>
      <div>
        <h4>
          <b-badge
            :variant="
              fields.status.includes(APPROVEMENT_STATUS.UNDER_ANALYSIS)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(APPROVEMENT_STATUS.UNDER_ANALYSIS)"
          >
            {{ getApprovementStatusText(APPROVEMENT_STATUS.UNDER_ANALYSIS) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(APPROVEMENT_STATUS.ACCEPTED)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(APPROVEMENT_STATUS.ACCEPTED)"
          >
            {{ getApprovementStatusText(APPROVEMENT_STATUS.ACCEPTED) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(APPROVEMENT_STATUS.DECLINED)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(APPROVEMENT_STATUS.DECLINED)"
          >
            {{ getApprovementStatusText(APPROVEMENT_STATUS.DECLINED) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.length === Object.keys(APPROVEMENT_STATUS).length
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addAllStatus()"
          >
            Todos
          </b-badge>
        </h4>
      </div>
    </b-col>
    <b-col cols="12" class="mb-4 mt-sm-3">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="fields.startDate"
        :endDate.sync="fields.endDate"
        :limparDados="limpar"
        @click.native="list()"
      />
    </b-col>

    <b-col cols="12" sm="12" md="12" lg="6" xl="6">
      <label class="font-weight-bold">Número da solicitação</label>
      <input
        min="0"
        type="number"
        v-model.number="fields.requestNumber"
        class="form-control"
        @input="handleRequestNumber()"
        @keydown.enter="list()"
        @keyup="searchTimeOut()"
      />
    </b-col>
    <b-col cols="12" class="mt-4">
      <b-button variant="success" @click="list()">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
    </b-col>
    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">
        {{ pagination.total }} solicitações encontradas
      </h3>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        hover
        small
        show-empty
        empty-text="Sem solicitações encontradas"
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(status)="data">
          <SelectItems
            v-if="data.item.editing"
            label="name"
            v-model="fields.selectedOrders[`${data.item.id}`].newStatus"
            :items="approvementStatusItems"
            :loading="loading"
            :reduceFunction="(orderStatus) => orderStatus.id"
            placeholder="Novo status"
          />
          <span v-else>
            {{ getApprovementStatusText(data.item.status) }}
          </span>
        </template>
        <template #cell(createdDate)="data">
          <span>{{ data.item.createdAt }}</span>
        </template>
        <template #cell(updatedDate)="data">
          <span>{{ data.item.updatedAt }}</span>
        </template>
        <template #cell(actions)="data">
          <b-col style="width: 120px" class="pr-0">
            <b-button
              variant="outline-dark"
              size="sm"
              title="Detalhes do profissional"
              class="mr-2 mb-2"
              v-if="!data.item.editing"
              @click="
                $refs.professionalDetails.toggleOpen({
                  professionalId: data.item.professionalId,
                })
              "
            >
              <i class="fas fa-eye"></i>
            </b-button>
            <span v-if="whatClerkPermission()">
              <b-button
                v-if="
                  data.item.status === APPROVEMENT_STATUS.UNDER_ANALYSIS ||
                  data.item.status === APPROVEMENT_STATUS.DECLINED
                "
                variant="success"
                size="sm"
                title="Aprovar"
                class="mr-2 mb-2"
                @click="
                  accept({
                    requestId: data.item.id,
                    professionalId: data.item.professionalId,
                  })
                "
              >
                <i class="fas fa-check"></i>
              </b-button>
              <b-button
                v-if="data.item.status === APPROVEMENT_STATUS.UNDER_ANALYSIS"
                variant="danger"
                size="sm"
                title="Recusar"
                class="mr-2 mb-2"
                @click="
                  decline({
                    requestId: data.item.id,
                    professionalId: data.item.professionalId,
                  })
                "
              >
                <i class="fas fa-ban"></i>
              </b-button>
            </span>
          </b-col>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>

    <ProfessionalDetails ref="professionalDetails" />
    <VideoManual ref="videoManual"/>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import APPROVEMENT_STATUS from 'Enums/Professional/ApprovementStatus';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import PageTitle from 'Components/PageTitle.vue';
import makeToast from 'Mixins/makeToast';
import SelectItems from 'Components/Inputs/SelectItems.vue';
import ProfessionalDetails from '../ProfessionalDetails.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: 'ApprovementRequestsList',
  mixins: [makeToast],
  components: {
    PageTitle,
    SelectItems,
    ProfessionalDetails,
    PeriodsFilters,
    VideoManual
  },
  data() {
    return {
      APPROVEMENT_STATUS,
      loading: false,
      limpar: false,
      showConfirmationPopover: false,
      currentRequestBeingEditedId: 0,
      fields: {
        requestNumber: '',
        status: [],
        startDate: '',
        endDate: ''
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'id',
            label: 'Id da solicitação',
            sortable: true,
          },
          {
            key: 'status',
            label: 'Situação',
            sortable: true,
          },
          {
            key: 'createdDate',
            label: 'Data de solicitação',
            sortable: true,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'professionalName',
            label: 'Profissional',
            sortable: true,
          },
          {
            key: 'updatedDate',
            label: 'Atualizado em',
            sortable: true,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
      timer: null,
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    approvementStatusItems() {
      const items = [];

      Object.keys(APPROVEMENT_STATUS).forEach((key) => {
        items.push({
          id: APPROVEMENT_STATUS[key],
          name: this.getApprovementStatusText(APPROVEMENT_STATUS[key]),
        });
      });

      return items;
    },
  },
  watch: {
    'pagination.currentPage': function () {
      this.list();
    },
  },
  mounted() {
    this.list();
  },
  methods: {
    ...mapActions('shopkeeper', [
      'listProfessionalRequestApprovals',
      `acceptProfessional`,
      `declineProfessional`,
    ]),
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.list();
      }, 800);
    },
    list() {
      this.loading = true;

      const { requestNumber, status, startDate, endDate } = this.fields;

      this.listProfessionalRequestApprovals({
        currentPage: this.pagination.currentPage,
        userId: this.userTypeId(),
        status: status.join(','),
        requestNumber,
        startDate,
        endDate
      })
        .then((response) => {
          const { perPage, total, data } = response.data.data || {};

          this.pagination.itemsPerPage = perPage || 15;
          this.pagination.total = total || 0;

          this.$set(this.table, 'records', data || []);
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as solicitações',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    accept({ requestId, professionalId }) {
      this.loading = true;

      this.acceptProfessional({
        userId: this.userTypeId(),
        professionalId,
      })
        .then(() => {
          this.setEditedValuesToOrderInTable(requestId, {
            newStatus: APPROVEMENT_STATUS.ACCEPTED,
          });
          this.makeToast('Sucesso', 'Solicitação aprovada com sucesso');
        })
        .catch((error) => {
          const { message } = error.response.data || {};

          this.makeToast(
            'Erro',
            message || 'Houve um erro ao atualizar a solicitação',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    decline({ requestId, professionalId }) {
      this.loading = true;

      this.declineProfessional({
        userId: this.userTypeId(),
        professionalId,
      })
        .then(() => {
          this.setEditedValuesToOrderInTable(requestId, {
            newStatus: APPROVEMENT_STATUS.DECLINED,
          });
          this.makeToast('Sucesso', 'Solicitação recusada com sucesso');
        })
        .catch((error) => {
          const { message } = error.response.data || {};

          this.makeToast(
            'Erro',
            message || 'Houve um erro ao atualizar a solicitação',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addStatus(status) {
      if (this.fields.status.includes(status)) {
        this.fields.status.splice(this.fields.status.indexOf(status), 1);
        this.list();
        return;
      }

      this.fields.status.push(status);
      this.list();
    },
    addAllStatus() {
      const validStatus = [
        APPROVEMENT_STATUS.UNDER_ANALYSIS,
        APPROVEMENT_STATUS.ACCEPTED,
        APPROVEMENT_STATUS.DECLINED,
      ];

      validStatus.forEach((value) => {
        if (this.fields.status.includes(value)) return;

        this.fields.status.push(value);
      });
    },
    setEditedValuesToOrderInTable(requestId, { newStatus }) {
      const order = this.table.records.find((x) => x.id === requestId);
      const index = this.table.records.indexOf(order);

      this.$set(this.table.records[`${index}`], 'status', newStatus);
    },
    handleRequestNumber() {
      if (!this.fields.requestNumber) return;

      this.$set(
        this.fields,
        'requestNumber',
        Math.abs(this.fields.requestNumber)
      );
    },
    getApprovementStatusText(status) {
      const texts = {
        [APPROVEMENT_STATUS.UNDER_ANALYSIS]: 'Sob análise',
        [APPROVEMENT_STATUS.ACCEPTED]: 'Aceito',
        [APPROVEMENT_STATUS.DECLINED]: 'Recusado',
      };

      return texts[status] || 'N/A';
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    typeRouteById(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? 'balconista-customizacoes-salvar-banner' : 'lojista-customizacoes-salvar-banner';
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.SOLICITACAO_PRO);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true;
    }
  },
};
</script>
